// React Imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// I18n
import { Translate } from 'react-redux-i18n';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';

// Project Components
import Progress from '../../global/Progress';
import { sfLangMapping } from '../../../i18n/config';


/**
 * Component for displaying the No Contact Exists Error Page.
 *
 * This component displays an error message and provides options to apply to join or
 * to sign out.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorNoContactExists />
 * )
 */
class ErrorNoContactExists extends Component {
  // Signs the user out so they can log in with a different Adobe ID.
  onSignOutClick = () => {
    window.adobeIMS.signOut();
  };

  onApplyJoinClick = () => {
    const { locale } = this.props;
    const sfLocale = Object.keys(sfLangMapping).includes(locale)
      ? sfLangMapping[locale]
      : 'en_US';
    const profile = window.adobeIMS.getUserProfile();
    const guid = profile.userId;
    const enrollLink = `${window.apcConfig.partner.enrollment}?lang=${sfLocale}&fn=${profile.first_name}&ln=${profile.last_name}&em=${profile.email}&aid=${profile.email}&guid=${guid}&countryCode=${profile.countryCode}`;
    window.open(enrollLink, '_self');
  };

  // Returns the current signed in user's email to insert into translation string.
  renderImsEmail = () => window.adobeIMS.getUserProfile().email;

  render() {
    return (
      <div>
        <Progress step={0} />
        <div className="page-container">
          <Heading>
            <Translate value="workflow.error_page.problem_header" />
          </Heading>
          <p>
            <Translate value="workflow.error_page.account_not_found" email={this.renderImsEmail()} />
          </p>
          <div className="button-container">
            <Button className="btn-applyJoin" variant="cta" onClick={this.onApplyJoinClick}><Translate value="workflow.error_page.apply_join" /></Button>
            <Button className="btn-signOut" onClick={this.onSignOutClick}><Translate value="global.ims.sign_out" /></Button>
          </div>
        </div>
      </div>
    );
  }
}

ErrorNoContactExists.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorNoContactExists);